import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import popularthingsbg from '../../../assets/images/popular-things-bg.png'

export default function PopularThings() {
    const place = useSelector(state => state.place);

    const popularThings = [
        { label: "Museum", img: "things1.png", category: "Museum" },
        { label: "Sightseeing / Tours", img: "seeingtours.png", category: "Sightseeing" },
        { label: "Day Trip", img: "ttd_img3.png", category: "Day-Trip" },
        { label: "Top Attractions", img: "ttd_img4.png", category: "Top-Attractions" },
        { label: "Night Life", img: "Nightlife.png", category: "Night-Life" },
        { label: "Shopping", img: "Shopping.png", category: "Shopping" },
        { label: "Fine Dining", img: "fine-dining.png", category: "Fine-dining" },
    ];

    return (
        <section
            className="section-equal-padding find-car-sec"
            style={{
                backgroundImage: `url(${popularthingsbg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "bottom",
            }}
            
        >
            <div className="container-fluid">
                <div className="row align-items-center popular_things_slider_icon">
                    <div className="col-md-12 col-xl-4 col-xxl-3">
                        <div
                            className="section-top-heading mb-3 mb-md-5 pb-70"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                        >
                            <h2 className="mb-2 text-white">Popular things to do</h2>
                            <p className="text-white">
                                Find fun places to see and things to do — experience art,
                                museums, music, and more.
                            </p>
                        </div>
                    </div>

                    <div className=" col-xl-8 col-xxl-9">
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            spaceBetween={20}
                            loop={true}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            navigation={true}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                768: { slidesPerView: 2 },
                                992: { slidesPerView: 3 },
                                1440: { slidesPerView: 4},
                                
                            }}
                            className="popularslider populatThinhs"
                        >
                            {popularThings.map((item, idx) => {
                                const safePlace =
                                    place && place.toLowerCase() !== item.category.toLowerCase()
                                        ? place
                                        : "";

                                const url = safePlace
                                    ? `/things-to-do/${item.category}/${encodeURIComponent(safePlace)}`
                                    : `/things-to-do/${item.category}`;
                                return (

                                    <SwiperSlide className="special-card-box" key={idx}>
                                        <figure>
                                            <img
                                                src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/${item?.img}`}
                                                alt={item?.category}
                                            />
                                        </figure>

                                        <div className="specialCard-content">
                                            <Link to={url}>
                                                {item.label}
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
}
